import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';

import { withRouter } from "react-router-dom";

@inject('ostolaskuStore')
@withRouter
@observer
class ConfirmButtons extends Component {

  handleInfoChange = (e) => {
    e.preventDefault();
    this.props.ostolaskuStore.setHUOM(e.target.value);
  }

  isAcceptable = () => {
    const receipt = this.props.ostolaskuStore.receipt;

    return !!receipt.TOIMITTAJANIMI &&
      !!receipt.TOIMITTAJAIBAN &&
      receipt.LASKUNSUMMA !== 0 &&
      receipt.ERAPVM >= receipt.LASKUPVM;
  }

  render() {
    const { ostolaskuStore } = this.props;
    const receipt = this.props.ostolaskuStore.receipt;
    const showButtons = ['KESKEN', 'HYVAKSYTTY'].includes(receipt.laskuvaihe);
    const HUOM = receipt.HUOM || '';
    return (
      ostolaskuStore.isUpdatingStatus ?
        <div className="row margin-md-vert" style={{ justifyContent: 'center', height: 50 }}>
          <CircularProgress size={70} />
        </div> :

        <div>
          {
            (showButtons || ostolaskuStore) &&
            <div className="padding-md">
              <TextField
                label={"Huomautukset"}
                multiline
                maxRows="4"
                value={HUOM}
                onChange={this.handleInfoChange}
                fullWidth
                disabled={!showButtons}
                autoFocus={true}
              />
            </div>
          }

          {
            showButtons &&
            <div>
              <div className="margin-md-vert row">
                <Button
                  variant="contained"
                  onClick={ostolaskuStore.reject}
                  className="flex margin-sm"
                  color="primary"
                >
                  <CloseIcon />&nbsp;
                  Hylkää
              </Button>

                <Button
                  variant="contained"
                  disabled={receipt.laskuvaihe === 'HYVAKSYTTY' || !this.isAcceptable()}
                  onClick={ostolaskuStore.accept}
                  className="flex margin-sm color-white"
                  classes={{ root: 'button-green' }}
                >
                  <CheckIcon />&nbsp;
                  Hyväksy
              </Button>
              </div>
              {
                !this.isAcceptable() &&
                <div className="color-red">
                  {
                    !receipt.TOIMITTAJANIMI &&
                    <div>Toimittajan nimi puuttuu</div>
                  }
                  {
                    !receipt.TOIMITTAJAIBAN &&
                    <div>Toimittajan tilinumero puuttuu</div>
                  }
                  {
                    receipt.LASKUNSUMMA === 0 &&
                    <div>Laskun summa on virheellinen</div>
                  }
                  {
                    receipt.ERAPVM <= receipt.LASKUPVM &&
                    <div>Eräpäivä ei ole laskun päivän jälkeen</div>
                  }
                </div>
              }
            </div>
          }
        </div>
    );
  }
}

export default ConfirmButtons;
